import { render, staticRenderFns } from "./PnOnboardingBanner.vue?vue&type=template&id=d9596564&scoped=true"
import script from "./PnOnboardingBanner.vue?vue&type=script&lang=js"
export * from "./PnOnboardingBanner.vue?vue&type=script&lang=js"
import style0 from "./PnOnboardingBanner.vue?vue&type=style&index=0&id=d9596564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9596564",
  null
  
)

export default component.exports